let queueOpeningCallback: (() => void) | null = null

export function setShowQueueCallback(callback: () => void): void {
  queueOpeningCallback = callback
}

export function showQueueView(): void {
  if (queueOpeningCallback) queueOpeningCallback()
}
